import { defineComponent as w, ref as d, computed as a, createElementBlock as z, openBlock as s, Fragment as S, createElementVNode as m, createBlock as $, createCommentVNode as b, normalizeClass as k, renderSlot as u, unref as o, withCtx as B, normalizeStyle as R } from "vue";
import { getSideAxis as c } from "@floating-ui/utils";
import { useFloating as x, autoUpdate as E, offset as F, flip as C, shift as M, size as H } from "@floating-ui/vue";
import { useResizeWithTarget as N } from "./useResizeWithTarget.js";
import T from "../ScalarTeleport/ScalarTeleport.vue.js";
const D = /* @__PURE__ */ w({
  inheritAttrs: !1,
  __name: "ScalarFloating",
  props: {
    placement: { default: "bottom" },
    offset: { type: [Number, Object, Function], default: 5 },
    resize: { type: Boolean, default: !1 },
    target: {},
    middleware: { default: () => [] },
    teleport: { type: [Boolean, String] }
  },
  setup(t) {
    const i = d(null), n = d(null), r = a(() => {
      var e;
      if (typeof window < "u" && n.value) {
        if (typeof t.target == "string") {
          const l = document.getElementById(t.target);
          if (l)
            return l;
          console.warn(`ScalarFloating: Target with id="${t.target}" not found`);
        } else if (t.target instanceof HTMLElement)
          return t.target;
        return ((e = n.value.children) == null ? void 0 : e[0]) || n.value;
      }
    }), f = N(r, {
      enabled: a(() => t.resize)
    }), g = a(
      () => c(t.placement) === "y" ? f.width.value : void 0
    ), h = a(
      () => c(t.placement) === "x" ? f.height.value : void 0
    ), { floatingStyles: p, middlewareData: y } = x(r, i, {
      placement: a(() => t.placement),
      whileElementsMounted: E,
      middleware: a(() => [
        F(t.offset),
        C(),
        M({ padding: 10 }),
        H({
          apply({ availableWidth: e, availableHeight: l, elements: v }) {
            Object.assign(v.floating.style, {
              maxWidth: `${Math.max(0, e) - 20}px`,
              maxHeight: `${Math.max(0, l) - 20}px`
            });
          }
        }),
        ...t.middleware
      ])
    });
    return (e, l) => (s(), z(S, null, [
      m("div", {
        ref_key: "wrapperRef",
        ref: n,
        class: k({ contents: !!e.$slots.default })
      }, [
        u(e.$slots, "default")
      ], 2),
      e.$slots.floating ? (s(), $(o(T), {
        key: 0,
        disabled: !e.teleport,
        to: typeof e.teleport == "string" ? e.teleport : void 0
      }, {
        default: B(() => [
          m("div", {
            ref_key: "floatingRef",
            ref: i,
            class: "relative z-context",
            style: R(o(p))
          }, [
            u(e.$slots, "floating", {
              data: o(y),
              height: h.value,
              width: g.value
            })
          ], 4)
        ]),
        _: 3
      }, 8, ["disabled", "to"])) : b("", !0)
    ], 64));
  }
});
export {
  D as default
};
